// sticky mobile nav

document.querySelector("#hamburger")?.addEventListener("click", function () {
  event.preventDefault();
  const toggleWrapper = document.querySelector(".mobile-toggle-wrapper");
  if (toggleWrapper) {
    console.log("enter");
    toggleWrapper.classList.toggle("active");
    if (toggleWrapper.hasAttribute("open")) {
      toggleWrapper.removeAttribute("open");
    } else {
      toggleWrapper.setAttribute("open", "true");
    }
  }
});

// Kwikpass changes
  function autoLogin (){
        // document.getElementById('kwik-pass-text').textContent = "My Account";
        document.getElementById('kp-account').classList.remove('kwik-pass-login');
        document.getElementById('kp-account').classList.add('kwik-pass-account');
        document.getElementsByClassName('kwik-pass-account')[0].addEventListener('click', function(e){
          handleShopifyLogin(e,"/account")
        });
      }
      window.addEventListener('user-loggedin', function(event) {
         const { token } = event?.detail;
         if (token){
           autoLogin();
         }
      });
    document.addEventListener('DOMContentLoaded',function () {
      var userToken = localStorage.getItem('KWIKSESSIONTOKEN');
      if (userToken){
        autoLogin();
      }
  })
class ProductMediaModal extends HTMLElement {
  constructor() {
    super();
    this.mediaImages = this.querySelectorAll('img');
    this.carouselEl = this.querySelector('slide-show');
    this.flickityInstance = Flickity.data(this.carouselEl);
    this.closeButton = this.querySelector('.product-slider-modal__close-btn');
    this.mediaThumbnails = this.previousElementSibling.children;
  }

  connectedCallback() {
    this.setupZoomEffect();
    this.setupMediaClickHandler();
    this.setupCloseButtonHandler();
    console.log(this.mediaThumbnails);
  }

  setupZoomEffect() {
  this.mediaImages.forEach((image) => {
    const imageWrapper = image.parentElement;

    let initialDistance = null;
    let currentScale = 1;
    let pos = { x: 0, y: 0 };
    let lastPos = { x: 0, y: 0 };
    let isPanning = false;
    let lastTap = 0;

    function getDistance(touch1, touch2) {
      const dx = touch2.clientX - touch1.clientX;
      const dy = touch2.clientY - touch1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    // Desktop hover zoom
    imageWrapper.addEventListener('mousemove', (event) => {
      if ('ontouchstart' in window) return;
      // Only if not zoomed by touch
      if (currentScale > 1) return;

      const rect = imageWrapper.getBoundingClientRect();
      const xPercent = ((event.clientX - rect.left) / rect.width) * 100;
      const yPercent = ((event.clientY - rect.top) / rect.height) * 100;
      image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      image.style.transform = 'scale(2.5)';
      imageWrapper.classList.add('image-zoom--scaled');
      this.carouselEl.classList.add('image-zoom--scaled');
    });

    imageWrapper.addEventListener('mouseleave', () => {
      if (currentScale === 1) {
        image.style.transform = 'scale(1) translate(0,0)';
        this.carouselEl.classList.remove('image-zoom--scaled');
        imageWrapper.classList.remove('image-zoom--scaled');
        pos = { x: 0, y: 0 };
      }
    });

    // Zoom out button
    imageWrapper.querySelector('.main-product__product-slider-btn-zoom-out-btn')?.addEventListener("click", () => {
      currentScale = 1;
      pos = { x: 0, y: 0 };
      image.style.transform = 'scale(1) translate(0,0)';
      this.carouselEl.classList.remove('image-zoom--scaled');
      imageWrapper.classList.remove('image-zoom--scaled');
      // Re-enable Flickity drag when zoom reset (if you toggle)
      if (this.flickityInstance) {
        this.flickityInstance.options.draggable = true;
        this.flickityInstance.updateDraggable();
      }
    });

    // Pinch zoom start
    imageWrapper.addEventListener('touchstart', (e) => {
      if (e.touches.length === 2) {
        initialDistance = getDistance(e.touches[0], e.touches[1]);
      } else if (e.touches.length === 1 && currentScale > 1) {
        // Pan start
        isPanning = true;
        lastPos.x = e.touches[0].clientX;
        lastPos.y = e.touches[0].clientY;
      }
    });

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
    // Pinch zoom and pan move
imageWrapper.addEventListener('touchmove', (e) => {
  if (e.touches.length === 1 && isPanning && currentScale > 1) {
    e.preventDefault();

    const dx = e.touches[0].clientX - lastPos.x;
    const dy = e.touches[0].clientY - lastPos.y;

    let newPosX = pos.x + dx;
    let newPosY = pos.y + dy;

    // Temporarily apply transform to check resulting position
    image.style.transform = `scale(${currentScale}) translate(${newPosX}px, ${newPosY}px)`;

    const wrapperRect = imageWrapper.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();

    image.style.transform = `scale(${currentScale}) translate(${pos.x}px, ${pos.y}px)`; // revert

    const buffer = 10;

    const canPanX =
      imageRect.left - wrapperRect.left < buffer &&
      wrapperRect.right - imageRect.right < buffer;

    const canPanY =
      imageRect.top - wrapperRect.top < buffer &&
      wrapperRect.bottom - imageRect.bottom < buffer;

    if (canPanX) {
      pos.x = newPosX;
    }

    if (canPanY) {
      pos.y = newPosY;
    }

    image.style.transform = `scale(${currentScale}) translate(${pos.x}px, ${pos.y}px)`;

    lastPos.x = e.touches[0].clientX;
    lastPos.y = e.touches[0].clientY;
  }
}, { passive: false });



    // Touch end
    imageWrapper.addEventListener('touchend', (e) => {
      if (e.touches.length < 2 && initialDistance) {
        const transform = image.style.transform;
        const matchedScale = transform.match(/scale\(([\d\.]+)\)/);
        currentScale = matchedScale ? parseFloat(matchedScale[1]) : 1;

        if (currentScale <= 1) {
          currentScale = 1;
          pos = { x: 0, y: 0 };
          image.style.transform = 'scale(1) translate(0,0)';
          imageWrapper.classList.remove('image-zoom--scaled');
          this.carouselEl.classList.remove('image-zoom--scaled');
          if (this.flickityInstance) {
            this.flickityInstance.options.draggable = true;
            this.flickityInstance.updateDraggable();
          }
        }
        initialDistance = null;
      }

      if (e.touches.length === 0) {
        isPanning = false;
      }
    });

    // Double tap to zoom in/out
    imageWrapper.addEventListener('touchend', (e) => {
      const now = Date.now();
      if (now - lastTap < 300) {
        // Double tap detected
        if (currentScale === 1) {
          currentScale = 2.5;
          image.style.transform = `scale(${currentScale}) translate(${pos.x}px, ${pos.y}px)`;
          imageWrapper.classList.add('image-zoom--scaled');
          this.carouselEl.classList.add('image-zoom--scaled');
          if (this.flickityInstance) {
            this.flickityInstance.options.draggable = false;
            this.flickityInstance.updateDraggable();
          }
        } else {
          currentScale = 1;
          pos = { x: 0, y: 0 };
          image.style.transform = 'scale(1) translate(0,0)';
          this.carouselEl.classList.remove('image-zoom--scaled');
          imageWrapper.classList.remove('image-zoom--scaled');
          if (this.flickityInstance) {
            this.flickityInstance.options.draggable = true;
            this.flickityInstance.updateDraggable();
          }
        }
      }
      lastTap = now;
    });
  });
}

  setupMediaClickHandler() {
    Array.from(this.mediaThumbnails).forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        this.classList.add('main-product__product-slider-modal--active');
        
        const imageIndex = thumbnail.dataset.index - 1;

        setTimeout(() => {
          this.flickityInstance.resize();
          this.flickityInstance.select(imageIndex, false, true);
        }, 50);
      });
    });
  }

  setupCloseButtonHandler() {
    this.closeButton?.addEventListener('click', () => {
      this.classList.remove('main-product__product-slider-modal--active');
    });
  }
}
customElements.define('product-slider-modal', ProductMediaModal);
class DownloadAppCTA extends HTMLElement {
  constructor() {
    super();
    this.deepLinkUrl = null;
    this.playStoreUrl = null;
    this.appstoreUrl = null;
    this.fallbackTimeout = 1500;
    this.handleClickEvents = this.handleClickEvents.bind(this);
  }

  connectedCallback() {
    const wrapper = this.closest('.footer-app-cta');
    if (wrapper) {
      this.deepLinkUrl = wrapper.dataset.onelinkUrl || null;
      this.playStoreUrl = wrapper.dataset.playstoreUrl || null;
      this.appstoreUrl = wrapper.dataset.appstoreUrl || null;
      if (wrapper.dataset.fallbackTimeout) {
        const parsedTimeout = parseInt(wrapper.dataset.fallbackTimeout, 10);
        if (!Number.isNaN(parsedTimeout)) {
          this.fallbackTimeout = parsedTimeout;
        }
      }
    }
    this.addEventListener('click', this.handleClickEvents);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClickEvents);
  }

  detectPlatform() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
    return { isAndroid, isIOS, isMobile };
  }

  openUrl(url) {
    if (url) window.location.href = url;
  }

  handleClickEvents() {
    const { isAndroid, isIOS } = this.detectPlatform();

    // No valid URLs provided
    if (!this.deepLinkUrl && !this.playStoreUrl && !this.appstoreUrl) {
      console.warn('No valid URLs found for DownloadAppCTA.');
      return;
    }

    // Android deep link handling
    if (isAndroid) {
      if (this.deepLinkUrl && this.playStoreUrl) {
        let success = false;

        const successHandler = () => {
          success = true;
        };

        document.addEventListener('visibilitychange', successHandler);
        window.addEventListener('blur', successHandler);

        this.openUrl(this.deepLinkUrl);

        setTimeout(() => {
          document.removeEventListener('visibilitychange', successHandler);
          window.removeEventListener('blur', successHandler);

          if (!success) {
            this.openUrl(this.playStoreUrl);
          }
        }, this.fallbackTimeout);
      } else {
        this.openUrl(this.playStoreUrl || this.deepLinkUrl);
      }

      return;
    }

    // iOS deep link handling
    if (isIOS) {
      if (this.deepLinkUrl && this.appstoreUrl) {
        let success = false;

        const successHandler = () => {
          success = true;
        };

        document.addEventListener('visibilitychange', successHandler);
        window.addEventListener('blur', successHandler);

        this.openUrl(this.deepLinkUrl);
        
        setTimeout(() => {
          document.removeEventListener('visibilitychange', successHandler);
          window.removeEventListener('blur', successHandler);

          if (!success) {
            this.openUrl(this.appstoreUrl);
          }
        }, this.fallbackTimeout);
      } else {
        this.openUrl(this.appstoreUrl || this.deepLinkUrl);
      }
      return;
    }

    // Desktop fallback
    if (this.classList.contains('footer-app-cta__cta-apple')) {
      this.openUrl(this.appstoreUrl);
    } else {
      this.openUrl(this.playStoreUrl);
    }
  }
}

customElements.define('download-app-cta', DownloadAppCTA);

document.addEventListener('DOMContentLoaded', function () {
  const footerSecondaryNavigation = document.querySelector('.footer-secondary-navigation');
  const openSingle = true;
  if (!footerSecondaryNavigation) return;

  function isMobile() {
    return window.innerWidth <= 767; 
  }

  footerSecondaryNavigation.addEventListener('click', function (event) {
    const mainTrigger = event.target.closest('.footer-secondary-navigation__trigger');
    if (mainTrigger) {
      const navBody = mainTrigger.nextElementSibling;
      const isActive = mainTrigger.classList.contains('footer-secondary-navigation__accordion-trigger--active');

      if (isActive) {
        navBody.style.height = navBody.scrollHeight + 'px';
        requestAnimationFrame(() => (navBody.style.height = '0'));
        mainTrigger.classList.remove('footer-secondary-navigation__accordion-trigger--active');
      } else {
        mainTrigger.classList.add('footer-secondary-navigation__accordion-trigger--active');
        navBody.style.height = '0px';
        requestAnimationFrame(() => (navBody.style.height = navBody.scrollHeight + 'px'));
        navBody.addEventListener(
          'transitionend',
          () => {
            if (mainTrigger.classList.contains('footer-secondary-navigation__accordion-trigger--active')) {
              navBody.style.height = 'auto';
            }
          },
          { once: true }
        );
      }

      mainTrigger.setAttribute('aria-expanded', isActive ? 'false' : 'true');
      return;
    }

    if (!isMobile()) return; 
    console.log(event.target);
    if (event.target.matches('.footer-secondary-navigation__l2-link-wrapper') || event.target.matches('.footer-secondary-navigation__l2-link') ){
      return;
    }
    const target = event.target.closest(
      '.footer-secondary-navigation__l1-link.footer-secondary-navigation__accordion-head'
    );
    if (target) {
      const submenu = target.querySelector('.footer-secondary-navigation__accordion-body');
      const submenuHeader = target.querySelector('.footer-secondary-navigation__l1-title');
      if (!submenu) return;

      // Close other open items
      if (openSingle) {
        const activeItem = footerSecondaryNavigation.querySelector(
          '.footer-secondary-navigation__l1-link.footer-secondary-navigation__accordion-head--active'
        );
        if (activeItem && activeItem !== target) {
          const activeSubmenuHeader = activeItem.querySelector('.footer-secondary-navigation__l1-title');
          const activeSubmenu = activeItem.querySelector('.footer-secondary-navigation__accordion-body');
          activeSubmenu.style.height = activeSubmenu.scrollHeight + 'px';
          requestAnimationFrame(() => (activeSubmenu.style.height = '0'));
          activeItem.classList.remove('footer-secondary-navigation__accordion-head--active');
          activeSubmenuHeader?.setAttribute('aria-expanded', false);
        }
      }

      // Toggle clicked item
      const isActive = target.classList.contains('footer-secondary-navigation__accordion-head--active');
      if (isActive) {
        submenu.style.height = submenu.scrollHeight + 'px';
        requestAnimationFrame(() => (submenu.style.height = '0'));
        target.classList.remove('footer-secondary-navigation__accordion-head--active');
        submenuHeader?.setAttribute('aria-expanded', false);
      } else {
        submenu.style.height = submenu.scrollHeight + 'px';
        target.classList.add('footer-secondary-navigation__accordion-head--active');
        submenu.addEventListener(
          'transitionend',
          () => {
            if (target.classList.contains('footer-secondary-navigation__accordion-head--active')) {
              submenu.style.height = 'auto';
            }
          },
          { once: true }
        );
        submenuHeader?.setAttribute('aria-expanded', true);
      }
    }
  });
});
